"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartConverter = void 0;
const LinkEntity_1 = require("../common/model/LinkEntity");
class CartConverter {
    static convertCart({ note, items, _links }) {
        return {
            note: note,
            items: items.map((it) => this.convertCartItem(it)),
            links: {
                self: new LinkEntity_1.Link(_links.self),
                addItem: new LinkEntity_1.Link(_links.addItem),
            },
        };
    }
    static convertCartItem({ id, _links, videoId, additionalServices, }) {
        return {
            id,
            videoId,
            additionalServices,
            links: {
                self: new LinkEntity_1.Link(_links.self),
                additionalServices: new LinkEntity_1.Link(_links.additionalServices),
            },
        };
    }
}
exports.CartConverter = CartConverter;
//# sourceMappingURL=CartConverter.js.map